const moment = require("moment");

function convertFormalityToBoolean(formality) {
  return formality == "Sie" ? true : false;
}

function getLanguageFromLocale(locale) {
  const lowerCaseLocale = locale?.toLowerCase() || "";

  if (lowerCaseLocale.includes("en")) {
    return "en";
  }

  if (lowerCaseLocale.includes("es")) {
    return "es";
  }

  return "de";
}

/**
 * Map questions to the format expected by the ATS
 *
 * @param {Array | undefined} questions - Array of questions
 * @param {boolean} isFormal - True if Sie, false if Du
 */
function mapQuestions(questions, isFormal) {
  if (!questions) return [];

  return questions.map((question) => {
    const selections = question.selections || [];
    const choices = selections.map((selection) => selection.text);
    const isMustHaveCriteria = selections.some((selection) => selection.isDisqualifying);
    const createdDate = moment().format();

    return {
      ...question,
      choices,
      isMustHaveCriteria,
      createdDate,
      isFormal
    };
  });
}

/**
 * Prepare the ATS document
 *
 * @param {Object} params
 * @param {string} params.formality - Formality (Sie or Du)
 * @param {Array} params.questions - Array of questions
 * @param {string} params.selectedChatbotQuestion - Selected chatbot question
 * @param {string} params.orgaId - Organization ID
 * @param {string} [params.applicationEmail] - Application email
 * @returns
 */
function prepareAtsDoc({
  formality,
  questions,
  selectedChatbotQuestion,
  orgaId,
  applicationEmail,
  campaignData = {}
}) {
  const isFormal = convertFormalityToBoolean(formality);
  const formQuestions = mapQuestions(questions, isFormal);

  const atsData = {
    config: {
      isFormal,
      formQuestions,
      firstChatbotQuestion: selectedChatbotQuestion,
      ...(applicationEmail ? { applicationEmail } : {})
    },
    ...(Object.keys(campaignData).length > 0 ? { campaignData } : {}),
    orgaId
  };
  return atsData;
}

module.exports = { prepareAtsDoc, convertFormalityToBoolean, getLanguageFromLocale };
